<template>
    <router-link
      class="navbar-brand navbar-brand-full"
      :style="styleLogo"
      :to="href"
      v-if="hideWidth <= windowWidth"
    >
      <b-img class="navbar-brand-image p-2" :src="imageSrc"/>
    </router-link>
</template>

<script>
export default {
  name: 'NavbarLogo',
  props: {
    href: {
      type: String,
      default: '/main'
    },
    windowWidth: {
      type: Number,
      default: 1280
    }
  },
  data() {
    return {
      defaultLogo: '/images/w1100_logo_custom.jpg',
      verticalLogo: '/images/vertical_logo_little.png',
      changeImageWidth: 550,
      changePosWidth: 750,
      hideWidth: 320
    }
  },
  computed: {
    imageSrc() {
      return this.windowWidth < this.changeImageWidth ? this.verticalLogo : this.defaultLogo
    },
    styleLogo() {
      let style = ''
      if (this.windowWidth < this.changeImageWidth) {
        style = 'width: fit-content; margin-left: 0; left: 40px;'
      } else if (this.windowWidth < this.changePosWidth) {
        style = 'left: 180px'
      }
      return style
    }
  }
}
</script>

<style scoped>

</style>
